module.exports = __webpack_public_path__ + "img/language.a89e5d5a.svg";